import { useState, useRef, useEffect } from "react";

const useAudioPlayer = ({ autoPlay = false, loop = false } = {}) => {
  const audioRef = useRef(new Audio());
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1); // de 0 à 1

  // Stocke les handlers pour pouvoir les enlever proprement
  const handlePlay = () => setIsPlaying(true);
  const handlePause = () => setIsPlaying(false);

  useEffect(() => {
    const audio = audioRef.current;
    audio.loop = loop;

    audio.addEventListener("play", handlePlay);
    audio.addEventListener("pause", handlePause);

    if (autoPlay) {
      audio.play().catch((err) => console.warn("Erreur autoPlay :", err));
    }

    return () => {
      destroy();
    };
  }, [autoPlay, loop]);

  const play = () => audioRef.current.play();
  const pause = () => audioRef.current.pause();
  const setSrc = (src) => {
    audioRef.current.src = src;
  };
  const setAudioVolume = (vol) => {
    audioRef.current.volume = vol;
    setVolume(vol);
  };

  const destroy = () => {
    const audio = audioRef.current;
    audio.pause();
    audio.src = "";
    audio.removeEventListener("play", handlePlay);
    audio.removeEventListener("pause", handlePause);
    setIsPlaying(false);
  };

  return {
    play,
    pause,
    setSrc,
    setVolume: setAudioVolume,
    isPlaying,
    volume,
    audio: audioRef.current,
    destroy,
  };
};

export default useAudioPlayer;
